<div mat-dialog-title>
  @if (showExplain) {
    <div>Verifying {{data.email}}</div>
  }
</div>
<div mat-dialog-content id='emailPanel'>
  @if (showExplain) {
    <div class="fx-col">
      <div>
        A verification email has been sent to this address. To continue your enrollment process please confirm you've
        received this email by entering the confirmation code in the box below, and click submit to continue. If you have not received the email with 2
        minutes, check the accuracy of the email address you provided (Please check your Junk/Spam folder).
      </div>
      <mat-form-field class="fx-flex-in-col" appearance="outline">
        <mat-label translate="unifiedapplication_confirmation_code"></mat-label>
        <div>
          <input name="confirmationCode" matInput [(ngModel)]="confirmationCode"
            nospaceallow="true" validate NOunderscore="true" validname="true">
        </div>
        @if (showErrorConfirmationCode) {
          <div>
            <small class="help-block has-errors">{{confirmationCodeErrorMessage}}</small>
          </div>
        }
      </mat-form-field>
      <div class="emailInputButton">
        <input name="submitConfirmationCode" matInput type="submit" (click)="checkConfirmationCode();">
      </div>
    </div>
  }

  @if (showExplain) {
    If you have not received the email with 2
    minutes, check the accuracy of the email address you provided or click <a
  (click)="verifyemailbylink(data.email)" style="color: var(--theme-deafult-secondary);">here</a> to resend
  the verification email.
}
@if (showExplain) {
  <section class="txt-center">
    <img style="width: 200px;" src="../../../../assets/images/ezgif.com-gif-maker.gif">
  </section>
}
@if (showExplain) {
  <div [mat-dialog-close]="true" class="emailInputButton">Close</div>
}
@if (emailVerified && !showExplain) {
  <p>Verified Successfully</p>
  <div [mat-dialog-close]="true" class="emailInputButton">Close</div>
}
</div>